// export function inspectionEventsFromNative(datas){
//     let inspectionEvents = [];
//
//     if(datas.length>0) datas.map((data)=>{
//         let inspectionEvent = {}
//         let inspection = {};
//         let model = {};
//         let modelCategory = {};
//         let inspectionStatus = {};
//         let user = {}
//         inspectionEvent.id = data[0]
//         inspectionEvent.serialCode = data[2]
//         inspectionEvent.customer_order_no = data[3]
//         inspectionEvent.productSKU=data[4]
//         inspectionEvent.productName=data[5]
//         inspectionEvent.performerName=data[8]?data[8]:(data[14]+" "+data[15])
//         inspectionEvent.performerRole=data[9]?data[9]:data[20]
//         inspectionEvent.created = data[12]
//
//         modelCategory.name = data[7]
//
//         model.systemType = data[6]
//         model.modelCategory = modelCategory
//
//         inspectionStatus.name = data[10]
//         inspectionStatus.label = data[11]
//
//         inspection.id = data[21]
//         inspection.reference = data[1]
//         inspection.model = model
//         inspection.inspectionStatus = inspectionStatus
//
//
//         inspectionEvent.inspection = inspection
//         inspectionEvent.inspectionStatus = inspectionStatus
//         if (data[13]){
//             user.id = data[13]
//             user.firstname = data[14]
//             user.lastname = data[15]
//             user.fullname = data[14]+" "+data[15]
//             let manufacturingSite = {}
//             manufacturingSite.id = data[16]
//             manufacturingSite.name = data[17]
//             user.manufacturingSite = manufacturingSite
//             inspectionEvent.user = user
//         }
//         inspectionEvents.push(inspectionEvent)
//     })
//
//     console.log("generatedEvents",inspectionEvents);
//     return inspectionEvents;
//
// }

export function inspectionEventsFromNative(datas){

    // [
    //     14255326,
    //     "2024000024",
    //     "240336300036",
    //     " ",
    //     " ",
    //     " ",
    //     "-48VDC OD / ID MODUFLEX SYSTEM -24KW",
    //     "-48VDC Rectifier Power System",
    //     "Alfarabi Dwi Karuniawan",
    //     "INSPECTOR",
    //     "Taken",
    //     "Dikerjakan",
    //     1750957758979,
    //     17887,
    //     "Alfarabi",
    //     "Dwi Karuniawan",
    //     "Globe",
    //     "2345506274",
    //     "J-J",
    //     1750957758982,
    //     "INSPECTOR",
    //     10898381
    // ],
    let inspectionEvents = [];

    if(datas.length>0) datas.map((data)=>{
        let inspectionEvent = {}
        let inspection = {};
        let model = {};
        let modelCategory = {};
        let inspectionStatus = {};
        let user = {}
        let manufacturingSite = {}
        inspectionEvent.id = data[0]
        inspectionEvent.serialCode = data[2]
        inspectionEvent.customer_order_no = data[3]
        inspectionEvent.productSKU=data[4]
        inspectionEvent.productName=data[5]
        inspectionEvent.performerName=data[9]
        inspectionEvent.performerRole=data[10]
        inspectionEvent.created = data[13]

        modelCategory.name = data[8]

        model.id = data[6]
        model.systemType = data[7]
        model.modelCategory = modelCategory

        inspection.reference = data[1]
        inspection.model = model

        user.id = data[14]
        user.firstname = data[15]
        user.lastname = data[16]
        user.fullname = data[15]+" "+data[16]
        manufacturingSite.id = data[17]
        manufacturingSite.name = data[18]
        user.manufacturingSite = manufacturingSite

        inspectionStatus.name = data[11]
        inspectionStatus.label = data[12]

        inspectionEvent.inspection = inspection
        inspectionEvent.inspectionStatus = inspectionStatus
        if (data[13]){
            inspectionEvent.user = user
        }
        inspectionEvents.push(inspectionEvent)
    })

    return inspectionEvents;

}